export const Constants = {
    WYNSTONBOTLINE : "Thinking",
    HELP_TEXT : "Provide the email address of a user who already has the required access. The requested access will be modeled after this user.",
    FIELD_DESCRIPTIONS: {
        GROUP: "GROUP",
        SELECT: "SELECT",
        LOOKUP: "LOOKUP",
        ENUMERATION: "ENUMERATION",
        SYSTEM_LOOKUP: "SYSTEM_LOOKUP",
        CUSTOM_LOOKUP: "CUSTOM_LOOKUP",
        SINGLE_SELECT: "SINGLE_SELECT",
        SINGLESELECT: "SINGLE-SELECT",
        MULTISELECT : "MULTI-SELECT",
        MULTI_SELECT: "MULTI_SELECT",
        BOOLEAN: "BOOLEAN",
        DATE: "DATE",
        DATETIME: "DATETIME",
        STRING: "STRING",
        TEXT: "TEXT",
        INTEGER: "INTEGER",
        NUMBER: "NUMBER",
        DECIMAL: "DECIMAL",
        CAPTION: "CAPTION",
        ASSIGNED_DEPARTMENT: "assignedServDept",
        scheduledStartDate: "scheduledStartDate",
        scheduledEndDate: "scheduledEndDate"
    },
    ATTACHMENTS: {
        VALUES: {
            MAX_FILES: 5,
            MAX_TOTAL_SIZE: 50,
            ALLOWED_EXTENSIONS: [
                "png", "jpg", "jpeg",
                "pdf",
                "zip",
                "doc", "docx",
                "xls", "xlsx",
                "txt",
                "csv"
            ]
        },
        MESSAGE: {
            MAX_FILES_REMOVE_ONE_TO_ADD_MORE: "You already have 5 attachments. Remove one to add more.",
            MAX_FILES_EXTRA_NOT_ADDED: "You can upload a maximum of 5 attachments. Extra files were not added.",
            TicketAttachmentMessage : "<b>You can also upload an attachment by clicking the attachment icon <i class='bi bi-paperclip des-attach-icon'></i> below and submit.</b>",
            TOTAL_ATTACHMENT_SIZE_EXCEEDED: "Total attachment size cannot exceed 50MB.",
            IFSAttachmentSupportedFormates : "PNG, JPEG, JPG, PDF, DOCX, ZIP, DOCX, XLS, XlSX, TXT"
        }
    }
}

export const ButtonsForUpdateTicket = (handleFunction, text, sliceLength,disable=false) => {
    return (
        <div
        onClick={() => {
        if (!disable) {
          handleFunction();
        }
        }} className="card border-1 wynston-border text-center d-flex align-items-center justify-content-center fixed-card" style={{cursor: disable ? "not-allowed" : "pointer",opacity: disable ? 0.5 : 1 }}                       
        >
            <div className="card-body p-1 d-flex flex-column justify-content-center align-items-center" >                   
            <p className="mb-0 text-center">
                <span className="d-block m-0 wynston-font-colour">{text.split(" ").slice(0, sliceLength).join(" ")}</span>
                <span className="d-block m-0 wynston-font-colour">{text.split(" ").slice(sliceLength).join(" ")}</span>                                                          
            </p>
            </div>
        </div>
    );
};